import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Route guard that redirects to login if not authenticated.
 */
function PrivateRoute() {
  const { token, loading, initialized } = useSelector((state) => state.auth);

  if (loading || !initialized) {
    return (
      <div className="loading-page">
        <div className="spinner spinner-lg" />
        <p>Loading...</p>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default PrivateRoute;
